import { ChevronLeftIcon, ChevronRightIcon } from '@repo/studio-design-system-ui-icons/arrows'
import { tw } from 'utils/classnames'

import { StudioIconButton } from '@repo/studio-components-buttons/studio-button'
import type {
  StudioButtonVariant,
  StudioButtonSize,
} from '@repo/studio-components-buttons/studio-button'

export function ScrollButton({
  buttonHeight,
  variant,
  buttonVariant = 'gray',
  buttonSize = 'medium',
  onClick,
}: {
  variant: 'left' | 'right'
  buttonHeight: number
  buttonVariant?: StudioButtonVariant
  buttonSize?: StudioButtonSize
  onClick: () => void
}) {
  return (
    <div
      className={tw(
        'absolute top-0 w-24 flex items-center pointer-events-none',
        variant === 'left' && 'left-0 justify-start',
        variant === 'right' && 'right-0 justify-end',
      )}
      style={{ height: buttonHeight }}
    >
      <StudioIconButton
        className="pointer-events-auto mx-4"
        size={buttonSize}
        variant={buttonVariant}
        onClick={onClick}
      >
        {variant === 'left' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
      </StudioIconButton>
    </div>
  )
}
